export class GetLiaisonAgents {
  static readonly type = '[Precis] Get all liaison agents'
  constructor(public language: string) {}
}
